transformFilters